import React from 'react';
import Modal from 'react-bootstrap/Modal';
import IconMail from '../../images/icon-mail.svg';
import IconPhone from '../../images/icon-phone.svg';
import './modal.scss';
const MyModal = (props) => {
	let modalContent;
	let modalHeader;
	if (props.modaltext == 'demo') {
		modalHeader = (
			<h1>
				Demotermin
				<span className='d-none d-sm-inline-block'>&nbsp;vereinbaren</span>
			</h1>
		);
		modalContent = (
			<p>
				<span className='d-none d-sm-block'>
					Sie möchten das Produkt kennen lernen?
				</span>
				Schreiben Sie uns eine Mail mit dem Betreff "Demotermin". Dann melden
				wir uns umgehend bei Ihnen, um eine 30-minütige Vorstellung des Produkts
				zu terminieren.
			</p>
		);
	} else {
		modalHeader = (
			<h1>
				Kontakt
				<span className='d-none d-sm-inline-block'>&nbsp;aufnehmen</span>
			</h1>
		);
		modalContent = (
			<p>
				Wenn Sie uns kennen lernen wollen oder einfach nur über Digitalisierung,
				Produktsicherheit oder die Chemieindustrie reden wollen, dann schreiben
				Sie uns oder rufen Sie uns an. Wir freuen uns auf Sie!
			</p>
		);
	}
	return (
		<Modal {...props} centered className='modal' size='lg'>
			<div className='dialog'>
				<Modal.Header>{modalHeader}</Modal.Header>
				<Modal.Body>
					{modalContent}
					<div className='contacts first-child'>
						<img src={IconMail} alt='' />
						<h1>
							<a href='mailto:info@sustragil.com'>info@sustragil.com</a>
						</h1>
					</div>
					<div className='contacts'>
						<img src={IconPhone} alt='' />
						<h1>
							<a href='tel:+491728699530'>+49 172 869 9530</a>
						</h1>
					</div>
				</Modal.Body>
			</div>
		</Modal>
	);
};
export default MyModal;
